import { createContext, useContext } from 'react';
import { Mode } from 'src/@types/mode';
import { OrgSSEData } from 'src/@types/org';

export type OrgContextType = {
  orgId: string;
  setOrgId: (orgId: string) => void;
  mode: Mode;
  setMode: (mode: Mode) => void;
  sseStatus: OrgSSEData | undefined;
};

const OrgContext = createContext<OrgContextType | null>(null);

export const useCurrentOrgContext = () => {
  const currentOrgContext = useContext(OrgContext);

  if (!currentOrgContext) {
    throw new Error('useCurrentOrgContext has to be used within <OrgContext.Provider>');
  }

  return currentOrgContext;
};

export default OrgContext;
